import { makeStyles,useTheme } from '@material-ui/core/styles';
import theme from 'theme';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    marginBottom: '8px'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonsGroup: {
    width: '185px',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '20px'
    }
  },
  heading: {
    fontWeight: '500',
    color: '#000000'
  },
  subTitleLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#748CA0'
  },
  launchIcon: {
    fontSize: '16px',
    marginLeft: '3px'
  },
  root: {
    marginBottom: '8px',
    boxShadow: 'none',
    border: '1px solid #E2EBF6',
    borderRadius: 3,
    '&:before': {
      display: 'none'
    },
    '&:last-child': {
      marginBottom: '30px'
    }
  },
  rootExpanded: {
    margin: '0 0 6px !important',
    '&:last-child': {
      marginBottom: '30px !important'
    }
  },
  rootSummary: {
    padding: '0 10px 0 10px',
    minHeight: '53px !important'
  },
  expandMoreIconRoot: {
    order: '-1'
  },
  expandMoreIcon: {
    fontSize: '19px',
    color: '#748CA0'
  },
  deleteIcon: {
    fontSize: '23px',
    color: '#59758B'
  },
  headerContentWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: '11px'
  },
  panelSummaryContent: {
    margin: '3px 0 !important'
  },
  panelDetailsRoot: {
    padding: '3px 30px 30px'
  },
  error: {
    border: '1px solid #EB5757'
  }
}));
